import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const keys = () =>
  createEnv({
    server: {
      RESEND_FROM: z.string().min(1).email(),
      RESEND_NOTIFICATIONS_FROM: z.string().min(1).email().optional(),
      RESEND_TO: z.string().min(1).email(),
      RESEND_TOKEN: z.string().min(1).startsWith('re_'),
    },
    runtimeEnv: {
      RESEND_FROM: process.env.RESEND_FROM,
      RESEND_NOTIFICATIONS_FROM: process.env.RESEND_NOTIFICATIONS_FROM,
      RESEND_TO: process.env.RESEND_TO,
      RESEND_TOKEN: process.env.RESEND_TOKEN,
    },
  });
